export type JobProduct = {
  id: string;
  name: string;
  display_name: string;
  initial_setup_cost_credits: number;
  job_creation_cost_credits: number;
  job_execution_cost_credits: number;
  job_subscriptions_count: number;
  created_at: string;
  modified_at: string;
};

/**
 * GET /api/v1/subscriptions/job-products/
 */
export const GET_JOB_PRODUCTS_PATH = 'subscriptions/job-products/';
export type GetJobProductsRequestQueryParams =
  | {
      limit?: number;
      offset?: number;
    }
  | undefined;
export type GetJobProductsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: JobProduct[];
};
export type GetJobProductsErrorDto = Error;

/**
 * POST /api/v1/subscriptions/job-products/
 */
export const POST_JOB_PRODUCT_PATH = 'subscriptions/job-products/';
export type PostJobProductRequestBodyData = {
  name: string;
  display_name: string;
  initial_setup_cost_credits: number;
  job_creation_cost_credits: number;
  job_execution_cost_credits: number;
};
export type PostJobProductErrorDto = Error;

/**
 * PATCH /api/v1/subscriptions/job-products/{id}/
 */
export const PATCH_JOB_PRODUCT_PATH = 'subscriptions/job-products/{id}/';
export type PatchJobProductRequestPathVariables = { id: string };
export type PatchJobProductRequestBodyData = Partial<PostJobProductRequestBodyData>;
export type PatchJobProductErrorDto = Error;

/**
 * DELETE /api/v1/subscriptions/job-products/{id}/
 */
export const DELETE_JOB_PRODUCT_PATH = 'subscriptions/job-products/{id}/';
export type DeleteJobProductRequestPathVariables = { id: string };
export type DeleteJobProductErrorDto = Error;
